import type { ICard } from "../../cardsSlice";

export const major1Card: ICard = {
    id: "major_1",
    arcana: "major",
    number: 1,
    suit: "major",
    court: "major",
    name: "Маг",
    nameEn: "The Magician",
    keywords: ["Созидание", "Воля", "Манифестация"],
    symbolism: [
      "Фигура с поднятой рукой и четырьмя символами мастей",
      "Знак бесконечности над головой",
      "Красно-белая одежда",
      "Сад с розами и лилиями"
    ],
    symbolismInterpretation:
      "Соединение духовного и материального; умение воплотить замысел в действие",
    archetype: "Архетип творца, сознательного действия и власти намерения",
    psychology: "Сила намерения, концентрация, осознанный контроль",
    upright: {
      personality: "Целеустремлённость, активность, сознательное влияние",
      relationships: "Открытость, инициативность, выразительность",
      work: "Навыки, ресурсность, манифестация проекта",
      spirituality: "Сознательное использование воли и энергии",
      examples: ["Новые проекты", "Самореализация", "Контроль над ситуацией"]
    },
    reversed: {
      meaning: "Манипуляция, злоупотребление знаниями, обман",
      nuances: "Потеря контроля, нечестные намерения"
    },
    associations: ["Власть", "Концентрация", "Намерение", "Мастерство"],
    combinations: [
      "С Императрицей — синергия творческой и волевой энергии",
      "С Дьяволом — корыстное использование силы"
    ],
    readingTips: ["Отличать истинное намерение от эгоистичного", "Анализировать влияние на других"],
    selfQuestions: ["Какие ресурсы я могу использовать?", "Чего я хочу добиться?"]
  };


